class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.cartDrawer = document.querySelector("cart-drawer");
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.itemsInCart = 1;
    this.giftWrapPreventAddToCart = this.dataset.preventAddToCart == "true";

    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener(
      "change",
      (event) => {
        event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
      },
    );

    if (!this.giftWrapPreventAddToCart) {
    } else if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrap();
    } else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.setGiftWrap();
    }

    this.initToggle();

    // Bind once and store the handler so it can be added/removed reliably.
    this.boundHandleQuantityDown = this.handleQuantityDown.bind(this);
  }

  connectedCallback() {
    if (this.boundHandleQuantityDown) {
      document.addEventListener("click", this.boundHandleQuantityDown, true);
    }
  }
    
  disconnectedCallback() {
    if (this.boundHandleQuantityDown) {
      document.removeEventListener("click", this.boundHandleQuantityDown, true);
    }
  }

  initToggle() {
    const toggleWrapper = this.closest(".gift-wrapping-toggle");
    if (!toggleWrapper) return;

    const toggleHeader = toggleWrapper.querySelector(
      ".gift-wrapping__toggle-header",
    );
    const content = toggleWrapper.querySelector(
      ".gift-wrapping__toggle-content",
    );

    toggleHeader.addEventListener("click", () => {
      const isOpen = toggleWrapper.hasAttribute("open");
      toggleWrapper.toggleAttribute("open");
      toggleHeader.setAttribute("aria-expanded", !isOpen);
      content.setAttribute("aria-hidden", isOpen);
    });
  }

  handleQuantityDown(evt) {
    const btn = evt.target.closest(".quantity-down");
    if (!btn) return;

    const cartItem = btn.closest(".cart-item");
    if (!cartItem) return;

    const input = cartItem.querySelector(".cart-item__quantity-input");
    if (!input) return;

    const href = btn.getAttribute("href") || "";
    if (href.includes(this.giftWrapId) && href.includes("quantity=0")) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      const checkbox = this.querySelector('[name="attributes[gift-wrapping]"]');
      checkbox.checked = false;
      this.removeGiftWrap();
    }
  }

  fetchCart(body) {
    return fetch(theme.routes.cartUpdate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then((r) => r.json());
  }

  setGiftWrap() {
    const sectionId = this.cartDrawer?.dataset.sectionId;

    this.fetchCart({
      updates: { [this.giftWrapId]: this.itemsInCart },
      attributes: { "gift-wrapping": true },
      sections: sectionId ? [sectionId] : [],
      sections_url: window.location.pathname,
    })
      .then((response) => {
        if (document.body.classList.contains("template-cart")) {
          window.location.href = theme.routes.cart;
          return;
        }

        if (this.cartDrawer && sectionId && response.sections?.[sectionId]) {
          this.cartDrawer.updateFromCartChange(response.sections[sectionId]);
        }
      })
      .catch((e) => console.error(e));
  }

  removeGiftWrap() {
    const sectionId = this.cartDrawer?.dataset.sectionId;

    this.fetchCart({
      updates: { [this.giftWrapId]: 0 },
      attributes: { "gift-wrapping": "" },
      sections: sectionId ? [sectionId] : [],
      sections_url: window.location.pathname,
    })
      .then((response) => {
        if (document.body.classList.contains("template-cart")) {
          window.location.href = theme.routes.cart;
          return;
        }

        if (this.cartDrawer && sectionId && response.sections?.[sectionId]) {
          this.cartDrawer.updateFromCartChange(response.sections[sectionId]);
        }
      })
      .catch((e) => console.error(e));
  }
}

if (!customElements.get('gift-wrapping')) {
    customElements.define('gift-wrapping', GiftWrapping);
}